import { Controller } from "@hotwired/stimulus"

// One "Ask me" row on the page editor (profile_pages/_answers): fill in a
// suggested question, ask the twin for a draft answer (the owner edits it
// before saving - nothing is on the page until they do), and listen to the
// recorded answer.
export default class extends Controller {
  static targets = ["question", "answer", "status", "draftButton"]
  static values = { url: String, row: String }

  suggest(event) {
    this.questionTarget.value = event.params.question
    this.questionTarget.focus()
  }

  // The editor sits in the side panel beside the list: its row follows the
  // question as it's typed (the save itself is profile-autosave's).
  syncRow() {
    if (!this.rowValue) return
    const label = document.getElementById(this.rowValue)?.querySelector(".profile-answer-question")
    if (label) label.textContent = this.questionTarget.value || "Untitled question"
  }

  async draft(event) {
    event.preventDefault()
    const question = this.questionTarget.value.trim()
    if (!question) {
      this._say("Write the question first.")
      this.questionTarget.focus()
      return
    }
    this.draftButtonTarget.disabled = true
    this._say("Your twin is drafting…")
    try {
      const token = document.querySelector("meta[name=csrf-token]")?.content
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token },
        body: JSON.stringify({ question })
      })
      const data = await response.json()
      if (data.ok) {
        this.answerTarget.value = data.answer
        this._say("A draft - edit it, then save.")
        this.answerTarget.focus()
      } else {
        this._say(data.error || "Your twin couldn't draft that one.")
      }
    } catch (_error) {
      this._say("Your twin couldn't draft that one. Try again.")
    } finally {
      this.draftButtonTarget.disabled = false
    }
  }

  listen(event) {
    event.preventDefault()
    if (!this._audio) this._audio = new Audio()
    this._audio.src = `${event.params.audio}?t=${Date.now()}`
    this._audio.play().catch(() => {})
  }

  _say(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
